export const XApiTokenVuexPlugin = store => {
  store.$refreshXApiToken = (axiosInstance, data, successCallback = null) => {
    if (store.state.apiToken.refreshTokenRequest) {
      return store.state.apiToken.refreshTokenRequest;
    }

    const tokenRequest = axiosInstance
      .post('/v2/token', data, { headers: { Authorization: '' } })
      .then(res => {
        if (res.status === 200) {
          store.commit('apiToken/setToken', { token: res.data.apiToken });

          if (typeof successCallback === 'function') {
            successCallback();
          }
        }
      })
      .finally(() => {
        store.commit('apiToken/setRefreshTokenRequest', null);
      });

    store.commit('apiToken/setRefreshTokenRequest', tokenRequest);
    return tokenRequest;
  };
};
